"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeystoneService = exports.TYPE_KEYSTONE_SIGN = exports.TYPE_KEYSTONE_GET_PUBKEY = void 0;
const router_1 = require("@keplr-wallet/router");
const keyring_1 = require("../keyring");
const cosmos_keyring_1 = require("./cosmos-keyring");
const types_1 = require("@keplr-wallet/types");
const ethereum_keyring_1 = require("./ethereum-keyring");
const tx_1 = require("@ethereumjs/tx");
const transactions_1 = require("@ethersproject/transactions");
const secp256k1_1 = require("secp256k1");
const common_1 = __importDefault(require("@ethereumjs/common"));
const cosmos_1 = require("@keplr-wallet/cosmos");
exports.TYPE_KEYSTONE_GET_PUBKEY = "keystone-get-pubkey";
exports.TYPE_KEYSTONE_SIGN = "keystone-sign";
var SignFunction;
(function (SignFunction) {
    SignFunction["Amino"] = "signAminoTransaction";
    SignFunction["Direct"] = "signDirectTransaction";
})(SignFunction || (SignFunction = {}));
var EthSignFunction;
(function (EthSignFunction) {
    EthSignFunction["Transaction"] = "signTransaction";
    EthSignFunction["Message"] = "signMessage";
    EthSignFunction["Data"] = "signTypedData";
})(EthSignFunction || (EthSignFunction = {}));
class KeystoneService {
    constructor(kvStore) {
        this.kvStore = kvStore;
    }
    init(interactionService) {
        this.interactionService = interactionService;
    }
    getPubkey(env, bip44HDPath) {
        return __awaiter(this, void 0, void 0, function* () {
            const keyring = cosmos_keyring_1.useKeystoneCosmosKeyring({
                readUR: () => __awaiter(this, void 0, void 0, function* () {
                    const res = (yield this.interactionService.waitApprove(env, "/keystone/import-pubkey", exports.TYPE_KEYSTONE_GET_PUBKEY, {
                        bip44HDPath,
                    }, {
                        forceOpenWindow: true,
                        channel: "keystone",
                    }));
                    if (res.abort) {
                        throw new router_1.KeplrError("keystone", 301, "The process has been canceled.");
                    }
                    if (!res.publicKey || !res.publicKey.cbor || !res.publicKey.type) {
                        throw new router_1.KeplrError("keystone", 302, "Public key is empty.");
                    }
                    return res.publicKey;
                }),
            });
            yield keyring.readKeyring();
            return keyring.getKeyringData();
        });
    }
    sign(env, coinType, bip44HDPath, key, keyringData, message, mode) {
        return __awaiter(this, void 0, void 0, function* () {
            let signResolve;
            let signReject;
            const keyring = cosmos_keyring_1.useKeystoneCosmosKeyring({
                keyringData,
                playUR: (ur) => __awaiter(this, void 0, void 0, function* () {
                    (() => __awaiter(this, void 0, void 0, function* () {
                        try {
                            const res = (yield this.interactionService.waitApprove(env, "/keystone/sign", exports.TYPE_KEYSTONE_SIGN, {
                                coinType,
                                bip44HDPath,
                                ur,
                                message,
                            }));
                            if (res.abort) {
                                throw new router_1.KeplrError("keystone", 301, "The process has been canceled.");
                            }
                            if (!res.signature) {
                                throw new router_1.KeplrError("keystone", 303, "Signature is empty.");
                            }
                            signResolve(res.signature);
                        }
                        catch (err) {
                            signReject(err);
                        }
                    }))();
                }),
                readUR: () => new Promise((resolve, reject) => {
                    signResolve = resolve;
                    signReject = reject;
                }),
            });
            const signFn = {
                [keyring_1.SignMode.Amino]: SignFunction.Amino,
                [keyring_1.SignMode.Direct]: SignFunction.Direct,
            }[mode];
            const res = yield keyring[signFn](Buffer.from(key.pubKey).toString("hex"), message, [Buffer.from(key.address).toString("hex")], "Keplr");
            return res.signature;
        });
    }
    signEthereum(env, coinType, chainId, bip44HDPath, key, keyringData, message, mode) {
        return __awaiter(this, void 0, void 0, function* () {
            let signResolve;
            let signReject;
            const keyring = ethereum_keyring_1.useKeystoneEthereumKeyring({
                keyringData,
                playUR: (ur) => __awaiter(this, void 0, void 0, function* () {
                    (() => __awaiter(this, void 0, void 0, function* () {
                        try {
                            const res = (yield this.interactionService.waitApprove(env, "/keystone/sign", exports.TYPE_KEYSTONE_SIGN, {
                                coinType,
                                bip44HDPath,
                                ur,
                                message,
                            }));
                            if (res.abort) {
                                throw new router_1.KeplrError("keystone", 301, "The process has been canceled.");
                            }
                            if (!res.signature) {
                                throw new router_1.KeplrError("keystone", 303, "Signature is empty.");
                            }
                            signResolve(res.signature);
                        }
                        catch (err) {
                            signReject(err);
                        }
                    }))();
                }),
                readUR: () => new Promise((resolve, reject) => {
                    signResolve = resolve;
                    signReject = reject;
                }),
            });
            const signFn = {
                [types_1.EthSignType.TRANSACTION]: EthSignFunction.Transaction,
                [types_1.EthSignType.MESSAGE]: EthSignFunction.Message,
                [types_1.EthSignType.EIP712]: EthSignFunction.Data,
            }[mode];
            let data = "";
            if (mode === types_1.EthSignType.TRANSACTION) {
                const msg = JSON.parse(Buffer.from(message).toString());
                const transactionType = +msg.type;
                if (transactionType === 2) {
                    // [EIP-1559](https://eips.ethereum.org/EIPS/eip-1559)
                    data = new tx_1.FeeMarketEIP1559Transaction(msg);
                }
                else if (transactionType === 1) {
                    // [EIP-2930](https://eips.ethereum.org/EIPS/eip-2930)
                    data = new tx_1.AccessListEIP2930Transaction(msg);
                }
                else {
                    const ethChainId = cosmos_1.EthermintChainIdHelper.parse(chainId);
                    data = new tx_1.Transaction(msg, {
                        // TODO: Other properties is need or not, such as "hardfork".
                        common: common_1.default.custom({ chainId: ethChainId.ethChainId }),
                    });
                }
            }
            else if (mode === types_1.EthSignType.MESSAGE) {
                data = Buffer.from(message).toString("hex");
            }
            else if (mode === types_1.EthSignType.EIP712) {
                data = JSON.parse(Buffer.from(message).toString());
            }
            const signRes = yield keyring[signFn](transactions_1.computeAddress(secp256k1_1.publicKeyConvert(key.pubKey, false)), data);
            if (mode === types_1.EthSignType.TRANSACTION) {
                const rlpData = signRes.serialize();
                return rlpData;
            }
            return Buffer.from(signRes.replace(/^0x/, ""), "hex");
        });
    }
}
exports.KeystoneService = KeystoneService;
//# sourceMappingURL=service.js.map